// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3-WFw","file":"styles_file__1x7i-"};